import LicenseValidator from './LicenseValidator';

export default LicenseValidator;
